import ProductById from './productById';

export default ProductById;